import { Injectable } from '@angular/core';
import {
	HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse, HttpErrorResponse
}
	from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import { AuthService } from "../pages/auth.service";
import { Router } from "@angular/router";
import has = Reflect.has;
//import * as boostrapNotify from ''
declare var $: any;

@Injectable()
export class HttpClientInterceptor implements HttpInterceptor {
	constructor(public authService: AuthService, private router: Router) {

	}

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		var host: string;

		if (has(localStorage, 'token') == false) {
			localStorage.setItem('token', '0')
		}

		if (!request.url.startsWith('./assets')) {

			if (request.url.startsWith('/api/v1')) {
				//host = 'http://192.168.1.18:3000';
				host = 'https://www.pagpdv.com.br';
				// host = 'http://localhost:3000';
			} else if (request.url.startsWith('viacep')) {
				host = 'https://';
			} else {
				if (request.url.startsWith('/auth/auth')) {
					console.log('entro');
					host = 'https://www.pagpdv.com.br'
					// host = 'http://localhost:3005';
				} else {
					if (request.url.startsWith('/auth/register')) {
						host = 'https://www.pagpdv.com.br'
						// host = 'http://localhost:3005';
					} else {
						if (request.url.startsWith('/api/')) {
							console.log('porque entra aqui');
							console.log(request.url, 'este es el request');
							host = 'https://www.pagpdv.com.br/api/v1/'
							// host = 'http://localhost:3000/api/v1/'
							// host = 'http://18.222.38.25:3002';
						} else {
							if (request.url.startsWith('/auth/')) {
								// host = 'https://www.seurestaurante.com:3006'
								host = 'https://www.pagpdv.com.br';
								// host = 'http://localhost:3005';
								// host = 'http://18.222.38.25:3002';
							} else {
								if (request.url.startsWith('/auth')) {
									host = 'https://www.pagpdv.com.br';
									// host = 'http://localhost:3005'
								} else {
									if (request.url.startsWith('/users')) {
										host = 'https://www.pagpdv.com.br';
										// host = 'http://localhost:3005'
									} else {
										host = '';

									}
								}
							}
						}
					}

				}

			}

			if (!(host.startsWith('https://www.pagpdv.c') || host.startsWith('https://pagpdv.c'))) {
				console.log('entro 2');
				if (!host.startsWith('/auth') && !host.startsWith('https://www.pagpdv.co')) {
					if (request.url.startsWith('viacep')) {
						request = request.clone({
							url: 'https://' + request.url,
						});
					} else {
						console.log('porque entra aqui 2');
						console.log(request.url, 'este es el request 2');
						if (request.url == '/auth/auth') {
							console.log('llego en auth auth');
							console.log(request.url, 'request url');
							request = request.clone({
								//url: 'https://' + request.url,
								// url: 'https://167.99.162.62:3005' + request.url.substr(5, request.url.length),


								url: 'http://localhost:3005' + request.url.substr(5, request.url.length),

								setHeaders: {
									'X-Auth-Token': localStorage.getItem('token')
								}
							});
							console.log(request.url, 'request url 2');
						} else if (request.url == '/auth/reset/') {
							console.log('llego en auth reset');
							request = request.clone({
								//url: 'https://' + request.url,
								// url: 'https://167.99.162.62:3005' + request.url.substr(5, request.url.length),
								url: 'http://localhost:3005' + request.url.substr(5, request.url.length),
								setHeaders: {
									'X-Auth-Token': localStorage.getItem('token')
								}
							});
						} else {
							console.log('llego aqui en api')
							request = request.clone({
								//url: 'https://' + request.url,
								// url: 'https://167.99.162.62:3005' + request.url.substr(5, request.url.length),
								url: 'http://localhost:3000/api/v1/' + request.url.substr(5, request.url.length),
								setHeaders: {
									'X-Auth-Token': localStorage.getItem('token')
								}
							});
						}
					}
				} else {
					if (request.url.startsWith('/api/')) {
						request = request.clone({
							url: host + request.url.substr(5, request.url.length),
							setHeaders: {
								'X-Auth-Token': localStorage.getItem('token')
							}
						});
					} else {
						request = request.clone({
							url: host + request.url,
							setHeaders: {
								'X-Auth-Token': localStorage.getItem('token')
							}
						});
					}

				}

			} else {
				console.log(host, 'host');
				if (request.url.startsWith('/api/')) {
					console.log('entrou no if api');
					request = request.clone({
						url: host + request.url.substr(5, request.url.length),
						setHeaders: {
							'X-Auth-Token': localStorage.getItem('token')
						}
					});
				} else {
					request = request.clone({
						url: host + request.url,
						setHeaders: {
							'X-Auth-Token': localStorage.getItem('token')
						}
					});
				}
			}

		} else {
			console.log('llego aqui charmander?');
			console.log(request.url, 'request');
			request = request.clone({
				url: request.url,
				setHeaders: {
					'X-Auth-Token': localStorage.getItem('token')
				}
			});
		}



		return next.handle(request).do<any>(event => {
			if (event.body) {
				if (event.body.error == 1) {
					this.errorOnLogin('top', 'right');
					console.log(this.router.url, 'router URL from interceptor');
					sessionStorage.setItem('previousRoute', '/crud/users');
					this.router.navigateByUrl('/pages/login');
				}
			}
		}, err => {
			// if (err.error == 1){
			//  this.errorOnLogin('top', 'right');
			// this.router.navigateByUrl('/pages/login');
			//}
		});
	}
	errorOnLogin(from, align) {
		$.notify({
			title: "Sua sessão expirou. Por favor <b>inicie sessão</b> novamente para continuar",
			message: "",
			icon: "warning",
			icon_type: "class",

		}, {
			type: 'danger',
			timer: 1000,
			delay: 600,
			placement: {
				from: from,
				align: align
			}
		});
	}
}


// WEBPACK FOOTER //
// ./src/app/interceptors/http.interceptor.ts